if (!customElements.get('quick-add-modal')) {
	customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
		constructor() {
			super();
			this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
		}

		hide(preventFocus = false) {
			const cartDrawer = document.querySelector('cart-drawer');
			if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);

			const swiperEl = this.modalContent.querySelector('.js-media-list');
			if (swiperEl && swiperEl.swiper) swiperEl.swiper.destroy(true, true);

			this.modalContent.innerHTML = '';

			if (preventFocus) this.openedBy = null;
			super.hide();
		}

		show(opener) {
			opener.setAttribute('aria-disabled', true);
			opener.classList.add('loading');

			if (opener.querySelector('.loading-overlay__spinner')) {
				opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');
			}

			fetch(opener.getAttribute('data-product-url'))
				.then((response) => response.text())
				.then((responseText) => {
					const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
					this.productElement = responseHTML.querySelector('[id^="MainProduct-"]');
					this.preventDuplicatedIDs();
					this.removeDOMElements();
					this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

					if (window.Shopify && Shopify.PaymentButton) {
						Shopify.PaymentButton.init();
					}

					if (window.ProductModel) window.ProductModel.loadShopifyXR();

					this.removeGalleryListSemantic();
					this.updateImageSizes();
					this.preventVariantURLSwitching();
					super.show(opener);
				})
				.then(() => {
					this.initModalSwiper();
				})
				.finally(() => {
					opener.removeAttribute('aria-disabled');
					opener.classList.remove('loading');
					if (opener.querySelector('.loading-overlay__spinner')) {
						opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
					}
				});
		}

		initModalSwiper() {
			const swiperEl = this.modalContent.querySelector('.js-media-list');
			if (!swiperEl || typeof Swiper === 'undefined') return;

			if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

			new Swiper(swiperEl, {
				slidesPerView: 1,
				spaceBetween: 4,
				allowTouchMove: true,
				touchReleaseOnEdges: true,
				observer: true,
				observeParents: true,
				navigation: {
					nextEl: '.quick-add-modal .swiper-btn--next',
					prevEl: '.quick-add-modal .swiper-btn--prev',
				},
				pagination: {
					el: '.quick-add-modal .product__media-list .swiper-pagination',
					clickable: true,
				},
				on: {
					slideChange: function () {
						if (window.pauseAllMedia) window.pauseAllMedia();
					}
				}
			});
		}

		setInnerHTML(element, html, opener) {
			element.innerHTML = html;

			// Re-inject only INLINE scripts. External scripts are already loaded globally;
			// re-injecting them causes update-slider.js and product-single.js to re-run
			// and reinitialize Swiper with global selectors, breaking the modal gallery.
			element.querySelectorAll('script').forEach(oldScriptTag => {
				if (oldScriptTag.getAttribute('src')) return;

				const newScriptTag = document.createElement('script');
				Array.from(oldScriptTag.attributes).forEach(attribute => {
					newScriptTag.setAttribute(attribute.name, attribute.value)
				});
				newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
				oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
			});

			const infoContainer = element.querySelector('.product__info-container');
			if (infoContainer) {
				const moreBtn = document.createElement('a');
				moreBtn.textContent = `${theme.quickviewMore}`;
				moreBtn.setAttribute('href', opener.getAttribute('data-product-url'));
				moreBtn.setAttribute('class', 'product__read-more button--simple full-unstyled-link h6');
				infoContainer.appendChild(moreBtn);
			}
		}

		removeDOMElements() {
			const pickupAvailability = this.productElement.querySelector('pickup-availability');
			if (pickupAvailability) pickupAvailability.remove();

			const productModal = this.productElement.querySelector('product-modal');
			if (productModal) productModal.remove();

			const gift = this.productElement.querySelector('.customer');
			if (gift) gift.remove();
		}

		preventDuplicatedIDs() {
			const sectionId = this.productElement.dataset.section;
			this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
			this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
				variantSelect.dataset.originalSection = sectionId;
			});
		}

		preventVariantURLSwitching() {
			if (this.modalContent.querySelector('variant-radios,variant-selects')) {
				this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
			}
		}

		removeGalleryListSemantic() {
			const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
			if (!galleryList) return;

			galleryList.setAttribute('role', 'presentation');
			galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
		}

		updateImageSizes() {
			const product = this.modalContent.querySelector('.product');
			if (!product) return;
			const desktopColumns = product.classList.contains('product--columns');
			if (!desktopColumns) return;

			const mediaImages = product.querySelectorAll('.product__media img');
			if (!mediaImages.length) return;

			let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

			if (product.classList.contains('product--medium')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '605px');
			} else if (product.classList.contains('product--small')) {
				mediaImageSizes = mediaImageSizes.replace('715px', '495px');
			}

			mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
		}
	});
}
